/* constant/development.js */
export default {
  environment: process.env.NODE_ENV,
  // apiUrl: 'http://192.168.168.152'
  // apiUrl: 'http://35.74.72.151'
  // apiUrl: 'http://13.230.101.50'
  apiUrl: 'https://elearningtest.issbg.site'
}



// WEBPACK FOOTER //
// ./src/constant/development.js